// @flow

import primaryLogo from './affirm_primary_logo.png';
import blackLogo from './affirm_black_logo.png';
import whiteLogo from './affirm_white_logo.png';

export const getAffirmLogoLink = (reader: string) => {
  return {
    primary: primaryLogo,
    black: blackLogo,
    white: whiteLogo,
  }[reader];
};
